// src/pages/RedirectAfterLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RedirectAfterLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/userpage");
    }, 1000); // 1000ms = 1 secundă pentru efect

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div style={{
      height: "100vh",
      backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.5rem",
      fontWeight: "bold"
    }}>
      Se incarca...
    </div>
  );
};

export default RedirectAfterLogin;
